var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quark-element-wrapper",on:{"click":_vm.handleClick}},[_c(_vm.element.elName,_vm._b({tag:"component",staticClass:"quark-element ani"},'component',_vm.element.propsValue,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }